import * as React from "react";
import SecurityEventDetails from "security-app/components/SecurityEvents/Alerts/EventDetails";
import { useGetSecurityEvent } from "security-app/hooks/useSecurityEventsAPI";
import { Spinner } from "components/common";
import { ModalProvider } from "common/contexts";
import AlertsModals from "security-app/components/SecurityEvents/Alerts/AlertsModals";
import EventDetailsContext from "security-app/components/SecurityEvents/Alerts/EventDetails/EventDetailsContext";
import usePermissions from "hooks/usePermissions";
import { DefaultDetailsWrapper } from "views/components/widgets/events/EventsList/EventDetails";
import permissions from "security-app/Permissions";
const EVENT_DETAILS_CONTEXT_VALUE = {
  hideEventDefinitionEdit: true,
  hideNotesEdit: true
};
const EventDetails = ({ eventId }) => {
  const { securityEvent, loadingSecurityEvents } = useGetSecurityEvent(eventId);
  if (loadingSecurityEvents || !securityEvent) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(ModalProvider, null, /* @__PURE__ */ React.createElement(EventDetailsContext.Provider, { value: EVENT_DETAILS_CONTEXT_VALUE }, /* @__PURE__ */ React.createElement(AlertsModals, null), /* @__PURE__ */ React.createElement(SecurityEventDetails, { orientation: "vert", securityEventId: securityEvent.event_id, interactiveTags: false })));
};
const EventDetailsWrapper = ({ eventId }) => {
  const { isPermitted } = usePermissions();
  if (!isPermitted([permissions.securityApp.read])) {
    return /* @__PURE__ */ React.createElement(DefaultDetailsWrapper, { eventId });
  }
  return /* @__PURE__ */ React.createElement(EventDetails, { eventId });
};
export default EventDetailsWrapper;
